import { motion } from "framer-motion";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="text-left"
        >
          <span className="block font-serif-lux text-2xl tracking-[0.18em] text-[#fcfcfc] leading-none">
            LUCAS
          </span>
          <span className="block text-[9px] tracking-[0.4em] uppercase text-[#d4af37] mt-1">
            Private Transfers
          </span>
        </button>
        <nav className="hidden md:flex items-center gap-10 text-[11px] tracking-[0.25em] uppercase text-[#888]">
          <button
            data-testid="nav-services-link"
            onClick={() => scrollTo("services")}
            className="hover:text-[#fcfcfc] transition-colors duration-300"
          >
            Services
          </button>
          <button
            data-testid="nav-fleet-link"
            onClick={() => scrollTo("fleet")}
            className="hover:text-[#fcfcfc] transition-colors duration-300"
          >
            Vehicle
          </button>
          <button
            data-testid="nav-manifesto-link"
            onClick={() => scrollTo("manifesto")}
            className="hover:text-[#fcfcfc] transition-colors duration-300"
          >
            Manifesto
          </button>
        </nav>
        <div className="flex items-center gap-6">
          <a
            href="tel:+61452512770"
            data-testid="nav-phone-link"
            className="hidden lg:block text-[11px] tracking-[0.25em] text-[#aaa] hover:text-[#d4af37] transition-colors duration-300"
          >
            0452 512 770
          </a>
          <button
            data-testid="nav-reserve-button"
            onClick={() => scrollTo("booking")}
            className="border border-[#d4af37]/60 text-[#d4af37] px-6 py-2.5 text-[11px] tracking-[0.25em] uppercase hover:bg-[#d4af37] hover:text-[#050505] transition-colors duration-500"
          >
            Book
          </button>
        </div>
      </div>
    </motion.header>
  );
}
